<template>
    <transition name="fade">
        <div class="liga-card" @click.prevent="goToNatjecatelji">
            <div class="icon"></div>
            <div class="desc">
                <Loading :loadingState="groupLoadingState">
                        <h4>{{ groupName }}</h4>
                        <p><span>{{ natjecateljiCount }}</span> natjecatelja</p>

                    <template v-slot:error>
                        Broj natjecatelja nepoznat
                    </template>
                </Loading>
            </div>
        </div>
    </transition>
</template>

<script>
import Loading from '../common/Loading'
import LoadingState from '../../utils/loading/LoadingState'
export default {
    name: 'groupsingle',
    data () {
        return {
            groupLoadingState: LoadingState.LOADING,
            groupName: null,
            natjecateljiCount: 0
        }
    },
    props: {
        groupId: null
    },
    components: {
        Loading
    },
    methods: {
        goToNatjecatelji () {
            this.$router.push(`/grupacija/${this.groupId}`)
        }
    },
    async mounted () {
        if (this.groupId) {
            try {
                let object = await this.$db.grupe.getGroupNameAndNatjecateljiCount(this.groupId)
                this.groupName = object.groupName
                this.natjecateljiCount = object.count
                this.groupLoadingState = LoadingState.SUCCESS
            } catch (error) {
                this.groupLoadingState = LoadingState.ERROR
            }
        } else {
            this.groupLoadingState = LoadingState.SUCCESS
        }
    }
}
</script>

<style lang="scss" scoped></style>
